import { ACTIONS_TEXT } from 'src/app/components/shared/shared-constants';

export const ColumnText = {
  TYPE: $localize`Stop Type`.toUpperCase(),
  DENSITY: $localize`Density`.toUpperCase(),
  CONSIGNEE: $localize`Consignee`.toUpperCase(),
  ADDRESS: $localize`Address`.toUpperCase(),
  STOP_DATE: $localize`Stop Date`.toUpperCase(),
  COMPLETION_TIME: $localize`Complete Time`.toUpperCase(),
  TRACKING_NUMBER: $localize`Tracking No.`.toUpperCase(),
  SCAN_CODE: $localize`Scan Code`.toUpperCase(),
  DESCRIPTION: $localize`Description`.toUpperCase(),
  AMOUNT_DUE: $localize`Amt Due`.toUpperCase(),
  AMOUNT_COLLECTED: $localize`Amount Collected`.toUpperCase(),
  ACTIONS: ACTIONS_TEXT,
};

export enum ColumnIds {
  TYPE = 'type',
  DENSITY = 'density',
  CONSIGNEE = 'cosignee',
  ADDRESS = 'address',
  STOP_DATE = 'stopDate',
  COMPLETION_TIME = 'completionTime',
  TRACKING_NUMBER = 'trackingNumber',
  SCAN_CODE = 'scanCode',
  DESCRIPTION = 'description',
  AMOUNT_DUE = 'amtDue',
  AMOUNT_COLLECTED = 'amtCollected',
  ACTIONS = 'actions',
}

export const EXCEL_FILE_NAME: string = $localize`route-details-pending-data`;

export const DATE_PLACEHOLDER: string = $localize`MM / DD / YYYY`;

export const BUTTON_TEXTS = {
  SAVE: $localize`Save`,
  COMPLETE: $localize`Complete`,
};
